import React, { useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  getKeyValue,
} from "@nextui-org/react";
import { LoaderCustom } from "../../components";
import {
  useAddAccountForStoreApi,
  useGetAllAccountApi,
  useGetAllAccountOfStoreApi,
} from "../../hooks";
import { Select, Spin } from "antd";
import { useAccountOfStore, useAccountStore } from "../../store";
import toast from "react-hot-toast";
import { LoadingOutlined } from "@ant-design/icons";

export default function AccountOfStore({ onOpenDetailMember }: any) {
  // state
  const [page, setPage] = useState(1);
  const [isLoader, setIsLoader] = useState(false);
  const [users, setUsers] = useState<any>([]);
  const [accountId, setAccountId] = useState<any>();
  const [reload, setReload] = useState(false);

  const { storeId } = useAccountOfStore();
  const { info } = useAccountStore();

  // api get store
  const { accountOfStore, isLoading } = useGetAllAccountOfStoreApi({ reload });

  const onChange = (value: string) => {
    setAccountId(value);
    onOpenDetailMember();
  };

  const onSearch = (value: string) => {};

  const rowsPerPage = 10;

  const { allAccount: apiAllAccount } = useGetAllAccountApi();
  const { mutate: $handleAddAccount, isPending: isPendingAddAccount } =
    useAddAccountForStoreApi();

  const handleAddAccount = async () => {
    if (!accountId) {
      return;
    }
    $handleAddAccount(
      {
        accountId: accountId,
        groupId: storeId,
      },
      {
        onSuccess: (response: any) => {
          if (response?.code === 200 || response?.message === 200) {
            toast.success(response?.message || "Add account successfully !");
            setReload(!reload);
          } else {
            toast.error(response?.error || "Add Account for store failure !");
          }
        },
        onError: (error: any) => {
          toast.error(
            error?.response?.data?.error || "Add Account for store failure !"
          );
        },
      }
    );
  };

  // useEffect for loader
  useEffect(() => {
    setIsLoader(true);
    setTimeout(() => {
      setIsLoader(false);
    }, 500);
  }, []);

  // useEffect for get data
  useEffect(() => {
    if (accountOfStore?.data?.length > 0) {
      const storeConvert = accountOfStore?.data?.map((item: any) => {
        return {
          // id: item?.id,
          email: item?.email,
          firstName: item?.firstName,
          lastName: item?.lastName,
          phoneNumber: item?.phoneNumber,
          // locked: item?.locked,
        };
      });
      setUsers(storeConvert);
    }
  }, [accountOfStore, isLoading]);

  const items = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;

    return users.slice(start, end);
  }, [page, users]);

  return (
    <>
      {isLoader && <LoaderCustom></LoaderCustom>}
      <div className="flex flex-col gap-1">
        {info?.role === "ROLE_ADMIN" && (
          <div
            onClick={(e) => e.stopPropagation()}
            className="lg:w-[50%] w-full justify-start items-start flex flex-col gap-2 mb-2"
          >
            <Select
              className="w-full"
              showSearch
              placeholder="Select a person"
              optionFilterProp="label"
              onChange={onChange}
              onSearch={onSearch}
              options={apiAllAccount?.data?.map((item: any) => {
                return {
                  value: item?.id,
                  label: item?.email,
                };
              })}
            />
            <button
              onClick={handleAddAccount}
              className="min-w-32 xl:py-[4px] lg:py-[3px] py-[2px] xl:px-[10px] lg:px-[8px] px-[6px] cursor-pointer hover:bg-opacity-90 bg-photo-time-pink-main flex justify-center items-center rounded-full"
            >
              {isPendingAddAccount ? (
                <Spin
                  className="text-white"
                  indicator={<LoadingOutlined spin />}
                  size="small"
                />
              ) : (
                <span className="text-sm text-white">Add account</span>
              )}
            </button>
          </div>
        )}

        <Table
          aria-label="Example table with client side pagination"
          classNames={{
            wrapper: "min-h-[32vh]",
            th: "text-center",
            td: "text-center",
          }}
        >
          <TableHeader>
            <TableColumn key="firstName">firstName</TableColumn>
            <TableColumn key="lastName">lastName</TableColumn>
            <TableColumn key="email">Email</TableColumn>
            <TableColumn key="phoneNumber">phoneNumber</TableColumn>
          </TableHeader>
          <TableBody items={items}>
            {(item: any) => (
              <TableRow key={item.email}>
                {(columnKey) => {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                      {getKeyValue(item, columnKey)}
                    </TableCell>
                  );
                }}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </>
  );
}
